import { DefaultPrimaryButton, DefaultSecondaryButton, SearchWithFilterInput, Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { Product } from '@frontend/product/utils';
import { FormattedMessage } from 'react-intl';

import KioskList from '../../../components/kiosk-list.component';
import { KioskNavigationFooter } from '../../../components/kiosk-navigation-footer.component';
import { KioskNavigationHeader } from '../../../components/kiosk-navigation-header.component';
import { EquipmentCard } from './equipment-card/equipment-card.component';
import { useEquipmentList } from './equipment-list.controller';

export const EquipmentList = () => {
    const viewProps = useEquipmentList();
    return (
        <div className='bg-background-default flex size-full flex-col overflow-hidden'>
            <KioskNavigationHeader
                title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)}
                onBack={() => viewProps.navigate(-1)}
            />
            {viewProps.isLoading && (
                <div className='flex flex-1 items-center justify-center p-6'>
                    <Spinner />
                </div>
            )}
            {!viewProps.isLoading && viewProps.hasError && (
                <div className='text-status-danger flex flex-1 items-center justify-center p-6'>
                    {viewProps.error ?? CommonMessage.ERRORS.ENTITY_NOT_FOUND(CommonMessage.OBJECTS.SLOT.DEFAULT)}
                </div>
            )}
            {!viewProps.isLoading && !viewProps.hasError && (
                <div className='text-foreground-default flex size-full flex-col items-start gap-6 overflow-y-auto p-6 font-medium'>
                    {viewProps.product && (
                        <div className='text-foreground-default justify-start text-lg font-semibold'>{new Product(viewProps.product).getDefaultName()}</div>
                    )}
                    <div className='w-full'>
                        <FormattedMessage
                            id='equipment-list.select-message'
                            defaultMessage='Select your equipment from the list to add it to the SLOT'
                        />
                    </div>
                    <SearchWithFilterInput
                        filterOptions={[
                            { label: CommonMessage.OBJECTS.ATTRIBUTE.PLURAL, key: 'attributes' },
                            { label: CommonMessage.OBJECTS.EQUIPMENT.DEFAULT, key: 'search' }
                        ]}
                        placeholder={viewProps.intl.formatMessage({
                            id: 'equipment-list.search-placeholder',
                            defaultMessage: 'Find by equipment'
                        })}
                        className='max-h-12'
                        selectedFilterKey={viewProps.searchKey}
                        onChange={viewProps.handleSearchChange}
                    />
                    <KioskList
                        id='equipment-list'
                        fetch={viewProps.fetch}
                        rowElement={(equipment) => (
                            <EquipmentCard
                                equipment={equipment}
                                onClick={() => viewProps.setSelectedEquipment(equipment)}
                                styles={{
                                    container: `${viewProps.selectedEquipment && viewProps.selectedEquipment.id === equipment.id ? 'border-brand-secondary bg-brand-light' : ''}`
                                }}
                            />
                        )}
                    />
                </div>
            )}
            <KioskNavigationFooter
                leftButton={
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.GO_BACK}
                        onClick={() => viewProps.navigate(-1)}
                        disabled={viewProps.isLoading}
                    />
                }
                rightButton={
                    <DefaultPrimaryButton
                        text={
                            <FormattedMessage
                                id='equipment-list.add-equipment'
                                defaultMessage='Add equipment'
                            />
                        }
                        onClick={() => viewProps.handleEquipmentAdd()}
                        disabled={!viewProps.selectedEquipment || viewProps.isLoading}
                        isLoading={viewProps.isSubmitting}
                    />
                }
            />
        </div>
    );
};
